import { useState } from "react";
import { Spinner } from "reactstrap";
import axios from "../../services/api/api";
import { API_BASE_URL } from "../../constants/api.constants";
import { FormattedMessage, useIntl } from "react-intl";
import { toast } from "react-toastify";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";
import { QAPI_URL } from "../../constants/api.constants";

export default function TeacherModuleAnswersAndDocs({
  module,
  answersAvaliable,
  answersFileName,
}) {
  const intl = useIntl();
  const [loading, setLoading] = useState(false);

  const handleOpenAnswers = () => {
    setLoading(true);
    axios
      .get(
        `${API_BASE_URL}/Module/GetModuleAnswers?moduleId=${module.moduleId}`,
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        const fileURL = URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = fileURL;
        link.download = answersFileName || `Facit-${module.moduleId}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(fileURL);
      })
      .catch(async (error) => {
        let responseObj = await error.response.data.text();
        if (responseObj.trim() === "FileNotFound") {
          toast.warn(
            <FormattedMessage id="Error_Code_Module_Answers_FileNotFound" />,
            TOAST_CONFIG
          );
        } else {
          toast.warn(
            responseObj ? (
              responseObj
            ) : (
              <FormattedMessage id="GenericApiError" />
            )
          );
        }
      })
      .finally(() => setLoading(false));
  };

  const handleOpenGy25ModuleAnswers = () => {
    setLoading(true);
    axios
      .post("/Course/GetModuleAnswers", {
        qApiId: module.qApiId,
      })
      .then((response) => {
        if (response.data?.result) {
          const data = JSON.parse(response.data.result);
          const win = window.open(
            `${QAPI_URL}/RT/RT?mode=5&lng=sv`,
            "",
            `fullscreen=yes,width=${window.screen.width},height=${window.screen.height}`
          );
          setTimeout(() => {
            win.postMessage({ fun: "init", param: { Data: data } }, "*");
          }, 2000);
        }
      })
      .catch((err) => {
        toast.warn(err?.message);
      })
      .finally(() => setLoading(false));
  };

  return (
    <button
      type="button"
      className="module-action-icon"
      disabled={loading || (!answersAvaliable && module.qApiId == null)}
      onClick={
        module.isGy25 && !module.isFinalExam && !module.isFactModule
          ? handleOpenGy25ModuleAnswers
          : handleOpenAnswers
      }
      title={intl.formatMessage({ id: "Answers" })}
      aria-label={intl.formatMessage({ id: "Answers" })}
    >
      {loading ? (
        <Spinner size="sm" />
      ) : (
        <img src="img/Facit.png" alt="" style={{ height: 24, width: "auto" }} />
      )}
    </button>
  );
}
